import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import Features from "@/components/landing/Features";
import Compatibility from "@/components/landing/Compatibility";
import Privacy from "@/components/landing/Privacy";
import About from "@/components/landing/About";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import WaitlistCTA from "@/components/landing/WaitlistCTA";
import Footer from "@/components/landing/Footer";
import useReveal from "@/hooks/useReveal";
import useSEO from "@/hooks/useSEO";

export default function Landing() {
    useReveal();
    useSEO({
        title: "Home",
        description:
            "LÜVYN — the anti-ghosting dating app. 5 curated matches every week. Quality over quantity. Compatibility isn't random.",
        canonical: "/",
    });

    return (
        <div
            className="relative min-h-screen overflow-x-hidden"
            data-testid="landing-root"
        >
            <div className="grain" />
            <Header />
            <main>
                <Hero />
                <Marquee />
                <HowItWorks />
                <Features />
                <Compatibility />
                <Privacy />
                <About />
                <FAQ />
                <Contact />
                <WaitlistCTA />
            </main>
            <Footer />
        </div>
    );
}
